import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { MasterCategoryTab } from './MasterCategoryTab';
import {
  sSubCategoriesOf, sCategoriesOf, addSSubCategory, updateSSubCategory, deleteSSubCategory,
} from '../../data/store';
import { useSharedStore } from '../../hooks/useSharedStore';
export const SSubCategoryTab = ({ org, showNotification }) => {
  const { version: dataVersion } = useSharedStore();
  const parents = useMemo(() => sCategoriesOf(org.id), [org.id, dataVersion]);
  return (
    <MasterCategoryTab
      org={org}
      title="S-Sub-Categories"
      singular="S-Sub-Category"
      list={() => sSubCategoriesOf(org.id)}
      needsParent
      parents={parents}
      parentLabel="Parent S-Category"
      onCreate={addSSubCategory}
      onUpdate={updateSSubCategory}
      onDelete={deleteSSubCategory}
      showNotification={showNotification}
    />
  );
};

SSubCategoryTab.propTypes = {
  org: PropTypes.object.isRequired,
  showNotification: PropTypes.func,
};
